import {forEach} from "lodash";

export function objectToFormData(object: unknown, formData = new FormData(), parent = '') {
    if (object === null) {
        object = '';
    }

    if (object === 'undefined' || typeof object === 'string' || object instanceof Blob) {
        formData.append(parent, object);
        return formData;
    }

    if (object instanceof Object) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        forEach(object, (item, property) => appendToFormData(formData, getKey(parent, property), item));
    }

    return formData;
}


function getKey(parent: string | null, property: string) {
    return parent ? parent + '[' + property + ']' : property;
}

function appendToFormData(formData: FormData, key: string, value: unknown) {
    if (value instanceof Date) {
        return formData.append(key, value.toISOString());
    }

    if (value instanceof File) {
        return formData.append(key, value, value.name);
    }

    if (typeof value === "boolean") {
        return formData.append(key, value ? '1' : '0');
    }

    if (value === null) {
        return formData.append(key, '');
    }

    if (value === 'undefined' || typeof value === 'string' || value instanceof Blob) {
        return formData.append(key, value);
    }

    objectToFormData(value, formData, key);
}

